<template>
  <div class="container-busca">
    
    <div class="row">
        <div class="col-sm-12">
      <h1 class="d-none d-sm-block">Gerenciamento de imóveis</h1>
      <h4 class="d-block d-sm-none">Gerenciamento de imóveis</h4><br>
    </div>

      <router-link to="/cadastro" class="col-sm-3  btn btn-warning d-none d-sm-block">+Cadastrar Novo Imóvel</router-link> 

      
      <button @click="fitroRapido(2,11)" class=" btn btn-sm  btn-info d-sm-block ml-1">Campestre VR</button> 
      <button @click="fitroRapido(3,11)" class=" btn btn-sm  btn-success d-sm-block ml-1">Campestre ED </button> 

            <button @click="fitroRapido(2,12)" class=" btn btn-sm  btn-info d-sm-block ml-1">Jardim VR</button> 
      <button @click="fitroRapido(3,12)" class=" btn btn-sm  btn-success d-sm-block ml-1">Jardim ED </button> 

            <button @click="fitroRapido(2,13)" class=" btn btn-sm  btn-info d-sm-block ml-1">V.Bastos VR</button> 
      <button @click="fitroRapido(3,13)" class=" btn btn-sm  btn-success d-sm-block ml-1">V.Bastos ED </button> 

            <button @click="fitroRapido(2,16)" class=" btn btn-sm  btn-info d-sm-block ml-1">Bela Vista VR</button> 
      <button @click="fitroRapido(3,16)" class=" btn btn-sm  btn-success d-sm-block ml-1">Bela Vista ED</button> 

      <div class="col-sm-12"><br></div>




<form class="row" method="POST" ref="formulario" @submit.prevent.stop="buscar">

  <div class="form-group col-sm-2">
            <label><strong>Referência:</strong></label>
            <input type="text" name="referencia" class="form-control" value="" v-model="referencia">
          </div>

    <div class="form-group col-sm-2 d-none d-sm-block">
        <label>Finalidade:</label>
        
        <select class="form-control d-none d-sm-block" name="vl" v-model="venda">
          <option value=""></option>
          <option value="Venda">Venda</option>
          <option value="Locação">Locação</option>
          <option value="Venda e Locação">Venda e Locação</option>
        </select>
      </div>

        <div class="form-group col-sm-2 d-none d-sm-block">
        <label>Ativo:</label>
        <select class="form-control" name="ativo" v-model="ativo">
          <option value="">Selecione</option>
        <option value="Sim">Sim</option>
        <option value="Não">Não</option>
    </select>
  </div>

 <div class="form-group col-sm-2 d-none d-sm-block">
        <label>Status:</label>
        
        <select class="form-control" name="status" v-model="status">
           <option value="">Selecione</option>
        <option value="Disponível">Disponível</option>
        <option value="Locado">Locado</option>
        <option value="Vendido">Vendido</option>
        <option value="Suspenso">Suspenso</option>
     
    </select>
  </div>

<!--
<div class="form-group col-sm-4">
          <label>Permuta:</label>
          <select class="form-control" name="permuta">
            <option value=""></option>
            <option value="Não">Não</option>
             <option value="Permuta maior">Permuta maior</option>
             <option value="Permuta menor">Permuta menor</option>
          </select>
        </div> -->


      <div class="form-group col-sm-4 d-none d-sm-block">
    <label>Tipo do imóvel</label>
    <select class="form-control" name="tipo" v-model="tipo">
       <option value=""></option>
      <option value="Apartamento">Apartamento</option>
      <option value="Apartamento sem condomínio">Apartamento sem condomínio</option>
      <option value="Cobertura">Cobertura</option>
      <option value="Casa térrea">Casa térrea</option>
      <option value="Sobrado">Sobrado</option>
       <option value="Sala">Sala</option>
        <option value="Galpão">Galpão</option>
         <option value="Outros">Outros</option>
    </select>
  </div>

          <div class="form-group col-sm-3">
          <label>Edificio:</label>
          <input type="hidden" name="edificio" :value="edificioID" />
          <AutocompleteCustom ref="autocomplete" :resultados.sync="matches" :nome.sync="edificioSelecionado" @pronto="addEdificio" url="autocompleteEdificios" classe="autocompleteEdificios"></AutocompleteCustom>
        </div>

          <div class="form-group col-sm-3">
          <label>Endereço:</label>
          <input type="text" name="endereco" class="form-control" value="" v-model="endereco">
        </div>

         <div class="form-group col-sm-3 d-none d-sm-block">
        <label>Bairro:</label>
        <select class="form-control" name="bairro" v-model="selectedBairro">
        <option v-for="item in bairros" :key="item.BAI_ID" :value="item.BAI_ID">{{item.BAI_NOME}}</option>
        
    </select>
  </div>

    <div class="form-group col-sm-3 d-none d-sm-block">
        <label>Cidade:</label>
        <select class="form-control" name="cidade" @change="getBairros" v-model="selectedCity">
          <option value="0"></option>
        <option v-for="item in cidades" :key="item.CID_ID" :value="item.CID_ID">{{item.CID_NOME}}</option>
        
    </select>
  </div>

    <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Dormitórios:</label>
          <input type="text" name="dormitorios" class="form-control" value="" v-model="dormitorios">
        </div>

        <!-- <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Suites:</label>
          <input type="text" name="suites" class="form-control" value="" v-model="suites">
        </div> -->

         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Garagens:</label>
          <input type="text" name="garagens" class="form-control" value="" v-model="garagens">
        </div>

        

    
       

  


        <!--<div class="form-group col-sm-2 d-none d-sm-block">
          <label>Lazer:</label>
          <select class="form-control" name="lazer" v-model="lazer">
            <option value=""></option>
            <option value="Sim">Sim</option>
            <option value="Não">Não</option>
          </select>
        </div>

         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Anunciados:</label>
          <select class="form-control" name="anunciados" v-model="anunciado">
            <option value=""></option>
            <option value="Sim">Sim</option>
            <option value="Não">Não</option>
          </select>
        </div> -->

        <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Metragem de:</label>
          <input type="text" name="metragem" class="form-control"  v-model="metragem" />
        </div>

        <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Até:</label>
          <input type="text" name="metragem2" class="form-control"  v-model="metragem2" />
        </div>
       


         <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Valor de:</label>
          <input type="text" name="valor" class="form-control" v-money="money" v-model.lazy="valor" />
        </div>

        <div class="form-group col-sm-2 d-none d-sm-block">
          <label>Até:</label>
          <input type="text" name="valor2" class="form-control" v-money="money" v-model.lazy="valor2" />
        </div>
  

  
     <div v-if="getPermissao() != 3 " class="form-group col-sm-4 d-none d-sm-block">
          <label>Captador Principal:</label>
            <select class="form-control" name="captador" v-model="captadorPrincipal">
            <option value="">Selecione</option>
            <option v-for="user in usuarios" :key="user.LOG_ID" :value="user.LOG_NOME">{{user.LOG_NOME}}</option>
            </select>
        </div>

  

          <button ref="buscar" type="submit" class="btn btn-warning col-sm" style="max-height:40px;margin-top:30px;">BUSCAR</button>
           <button  class="btn btn-danger col-sm ml-1" @click="limpar" type="button"  style="max-height:40px;margin-top:30px;">LIMPAR</button>

       </form>

    </div><!-- row -->

 


    <div class="row">

       <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

<br>
 <table class="col-sm table  ">
  <thead>
    <tr>
      <th scope="col">Referência</th>
      <th scope="col">Edificio</th>
      <th scope="col">Bairro</th>
      <th scope="col">Complemento</th>
       <th scope="col">M<sup>2</sup></th>
      <th scope="col">Status</th>
      <th scope="col"></th>
       <th scope="col">Valor</th>
       <th scope="col">Visualizar</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="item in imoveis" :key="item.IM_ID" >
      <th  scope="row">{{item.IM_ID}}</th>
      <td >{{item.ED_NOME}}</td>
      <td>{{item.BAI_NOME}}</td>
      <td >{{item.IM_COMPLEMENTO}}</td>
    <td>{{item.IM_AREAUTIL}}</td>
      <td v-if="item.IM_STATUS == 'Vendido' || item.IM_STATUS == 'Locado' || item.IM_STATUS == 'Suspenso'" style="color:red;font-weight:bold;">{{item.IM_STATUS}}</td>
      <td v-else >{{item.IM_STATUS}}</td>
       <td><img src="/img/check.png" style="width:50px;height:auto;display:inline-block;cursor:pointer;" class="mt-n2" :class="{'colorless':item.CHECADO == false}" @click="checkImovel(item)"/> </td>
      <td ><input style="width:140px" type="text" readonly v-money="money" :value="item.IM_VALOR" /></td>
     
      <td >
         <popper 
        trigger="hover"
        :options="{
          placement: 'left',
          modifiers: { offset: { offset: '0,10px' } }
        }">
        <router-link :to="'/edicao/'+item.IM_ID" class="btn btn-info" slot="reference">VISUALIZAR</router-link> 
          <div class="popper" style="width:300px;background:#F4E7B2;">
  
      <div class="d-flex flex-column pl-2">
       <h5 class=""><strong>{{item.IM_NOME_CONTATO}}</strong></h5>
        <p class=""><strong>Captação:</strong> <i>{{item.IM_CAPTADOR}}</i></p>
        <p class=""><strong>Dormitórios:</strong> <i>{{item.IM_DORMITORIOS}}</i></p>
        <p class=""><strong>Garagens:</strong> <i>{{item.IM_NUMERO_GARAGENS}}</i></p>
         <p class=""> <i><small>{{item.IM_ENDERECO}}</small></i></p>
        <p class=""> <i><small>{{item.IM_OBSERVACAO_CONTATO}}</small></i></p>
      </div>
    </div>
 
  </popper>
        </td>

     

    </tr>
   
  </tbody>
</table>

    </div><!-- row table -->



  </div>
</template>
<style>
.colorless{filter: grayscale(1);}
</style>
<script>
import axios from 'axios'
import AutocompleteCustom from '@/components/AutocompleteCustom'
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  name: 'Busca',
  components: {AutocompleteCustom,Popper},
  
  data(){
      return {
        referencia:'',
        status:'',
        endereco:'',
        dormitorios:'',
        suites:'',
        garagens:'',
        lazer:'',
        anunciado:'',
        venda:'Venda',
        tipo:'',
        ativo:'Sim',
        edificioID:'',
        edificioSelecionado:'',
             matches:[],
          imoveis:[],
          loading: false,
          valor:'',
          valor2:'',
          metragem:'',
          metragem2:'',
           cidades:[],
              bairros:[],
             selectedCity:5,
             selectedBairro:0,
             captadorPrincipal:'',
             usuarios:[],
          money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false,
            
             
          }
      }
  },
 

methods:{
  getPermissao(){
    return  sessionStorage.getItem('imobiliaria');
  },
   getUsuario(){
       return sessionStorage.getItem('imobiliariaNome');
     },
   checkImovel(item){
        this.loading = true;
          axios
          .get('https://www2.royaljardim.com.br/sistema/welcome/checkImovel/'+ item.IM_ID)
          .then(response => {console.log(response);
                          
                           item.CHECADO = true;
                            })
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },
   fitroRapido(tipo,regiao){
     this.loading = true;
      let fm = new FormData();

     fm.append('permissao',this.getPermissao());
     fm.append('corretor',this.getUsuario());

      
      switch(tipo){
        case 1:
          fm.append('orderBy','BAI_NOME ASC,IM_ID DESC');
         break;
          case 2:
          fm.append('orderBy','IM_VALOR DESC,IM_ID DESC');
         break;
           case 3:
          fm.append('orderBy','ED_NOME ASC');
         break;
      }
            
            fm.append('cidade',5);
             fm.append('vl','Venda');
             fm.append('status','Disponível');
              fm.append('tipo','Apartamento');
              fm.append('ativo','Sim');
              fm.append('bairro',regiao);

          //////
          let filtroSalvo = {tipo:tipo,bairro:regiao}
          this.$store.commit('changeFiltroRapido',filtroSalvo);
         
          //////

          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/buscaImovelRapido',fm)
          .then( response => {console.log(response);this.imoveis = response.data;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },
  limpar(){
          this.edificioID = '',
          this.edificioSelecionado = '',
          this.matches = '',
          this.valor = '',
           this.valor2 = '',

         this.selectedCity = '',
        this.selectedBairro = '',
         this.captadorPrincipal = '',
           this.referencia = '',
           this.status = '',
           this.endereco = '',
           this.dormitorios = '',
          this.suites = '',
           this.garagens ='',
           this.lazer = '',
           this.anunciado = '',
           this.venda = '',
           this.tipo = '',
           this.ativo = '',
           this.$refs.autocomplete.$refs.typeahead.inputValue = '';
            this.$store.commit('changeFiltro',null);
            this.$store.commit('change',null);
  },
  salvarFiltros(){
    return {
          edificioID: this.edificioID,
          edificioSelecionado:this.edificioSelecionado,
          matches:this.matches,
          imoveis: this.imoveis,
          loading: this.loading,
          valor:this.valor,
          valor2: this.valor2,
          cidades:this.cidades,
          bairros: this.bairros,
          selectedCity: this.selectedCity,
          selectedBairro: this.selectedBairro,
          captadorPrincipal:this.captadorPrincipal,
          usuarios: this.usuarios,
           referencia:this.referencia,
            status:this.status,
            endereco:this.endereco,
            dormitorios:this.dormitorios,
            suites:this.suites,
            garagens:this.garagens,
            lazer:this.lazer,
            anunciado:this.anunciado,
            venda:this.venda,
            tipo:this.tipo,
            ativo:this.ativo,
            edificio:this.$refs.autocomplete.$refs.typeahead.inputValue

    }
  },

   addEdificio(valor){
  
      this.edificioID = valor.ED_ID;
      
     
    },
     getEdificio(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getEdificio',{id:this.selectedEdificio})
          .then(response => {this.edificioSelecionado = response.data; this.$refs.autocomplete.preencher(response.data);})
          .catch(response => console.log(response))
          
    },
    getUsuarios(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getUsuarios',{})
          .then(response => this.usuarios = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    get(){
          this.loading = true;
          let fm = new FormData();
          fm.append('permissao',this.getPermissao());
          fm.append('corretor',this.getUsuario());

          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getImoveis',fm)
          .then(response => this.imoveis = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

     getCidades(){
          this.loading = true;
          axios
          .get('https://www2.royaljardim.com.br/sistema/welcome/getCidades')
          .then(response => this.cidades = response.data)
          .catch(response => console.log(response))
          .finally(() =>  {
                           this.loading = false; 
                           //this.selectedCity = this.cidades[0].CID_ID;
                           this.getBairros()
                           })
    },
    getBairros(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getBairros',{cidade:this.selectedCity})
          .then(response => {this.bairros = response.data;
                             
                              })
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    buscar(){
      let edificioPreenchido = this.$refs.autocomplete.$refs.typeahead.inputValue;
      if(edificioPreenchido == ''){
        this.edificioID = '';
      }

          this.loading = true;
          let fm = null;

            if(this.$store.state.filtro == null){
            fm = new FormData(this.$refs["formulario"]);
            fm.append('valor',this.filtrar(this.valor));
            fm.append('valor2',this.filtrar(this.valor2));
            fm.append('permissao',this.getPermissao());
            fm.append('corretor',this.getUsuario());
            this.$store.commit('changeFiltro',fm);
            }else{
              fm = this.$store.state.filtro;
              this.$store.commit('changeFiltro',null);
            }
          

          //////
          this.$store.commit('change',this.salvarFiltros());
         
          //////

          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/buscaImovel',fm)
          .then( response => {console.log(response);this.imoveis = response.data;})
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },

   
     filtrar(dinheiro){
      return dinheiro.replace('R$', "").replace('.', "").replace('.', "").replace(',', ".");
    }

},
  
  mounted() {
  let filtros = this.$store.state.busca;
  let filtrosRapidos = this.$store.state.filtroRapido;
  if(filtrosRapidos != null){
    this.getCidades();
    this.getUsuarios();
    this.fitroRapido(filtrosRapidos.tipo,filtrosRapidos.bairro);
    
    return;
  }
  if(filtros == null){
    this.get();
    this.getCidades();
    this.getUsuarios();

  }else{
    this.selectedBairro = filtros.selectedBairro;
    this.selectedCity = filtros.selectedCity;
    this.bairros = filtros.bairros;
    this.cidades = filtros.cidades;
    this.matches = filtros.matches;
    this.captadorPrincipal = filtros.captadorPrincipal;
    this.edificioID = filtros.edificioID;
    this.edificioSelecionado = filtros.edificioSelecionado;
    //this.imoveis = filtros.imoveis;
    this.valor = filtros.valor;
    this.valor2 = filtros.valor2;
    this.referencia = filtros.referencia;
    this.status = filtros.status;
    this.endereco = filtros.endereco;
    this.dormitorios = filtros.dormitorios;
    this.suites = filtros.suites;
    this.garagens = filtros.garagens;
    this.lazer = filtros.lazer;
    this.anunciado = filtros.anunciado;
    this.venda = filtros.venda;
    this.tipo = filtros.tipo;
    this.ativo = filtros.ativo;
    this.usuarios = filtros.usuarios;
    this.$refs.autocomplete.$refs.typeahead.inputValue = filtros.edificio;
    
    this.$refs.buscar.click();
  }


  }



}
</script>